import Vue from "vue";
import {PersonnelService,} from "../../common/api.service";
import {
    CANCEL_PERSON_HOLIDAY_ENTITLEMENT_EDIT_STATE,
    DELETE_PERSON_HOLIDAY_ENTITLEMENT,
    FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST,
    SAVE_EDITED_PERSON_HOLIDAY_ENTITLEMENT,
    SAVE_NEW_PERSON_HOLIDAY_ENTITLEMENT,
    UPDATE_HOLIDAY_ENTITLEMENT,
} from "./actions.js";
import {
    FETCH_PERSON_HOLIDAY_ENTITLEMENTS_END,
    LOAD_PERSON_HOLIDAY_ENTITLEMENT_TO_EDIT,
    RESET_DEFAULT_NEW_PERSON_HOLIDAY_ENTITLEMENT,
    RESET_DEFAULT_PERSON_HOLIDAY_ENTITLEMENT_TO_EDIT,
    TOGGLE_EDIT_PERSON_HOLIDAY_ENTITLEMENT_DIALOG,
    TOGGLE_NEW_PERSON_HOLIDAY_ENTITLEMENT_DIALOG,
    TOGGLE_PERSON_HOLIDAY_ENTITLEMENT_EDIT_STATE,
    UPDATE_ADD_PERSON_HOLIDAY_ENTITLEMENT_FIELD,
    UPDATE_EDIT_PERSON_HOLIDAY_ENTITLEMENT_FIELD,
} from "./mutations.js";
import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const state = {
    editPersonHolidayEntitlementInitialLoadFiscalYear: undefined,
    personHolidayEntitlementList: [],
    editStateHolidayEntitlement: {
        employmentType: false,
        weeklyHours: false,
        startDate: false,
        endDate: false,
        comments: false,
    },
    editPersonHolidayEntitlement: {},
    defaultPersonHolidayEntitlement: {
        fiscalYear: undefined,
        carriedOver: 0,
        yearlyEntitlement: 0,
        specialAllowance: 0,
        comments: '',
        holidayPeriod: 1,
    },
    addPersonHolidayEntitlement: {},
    addPersonHolidayEntitlementDialog: false,
    editPersonHolidayEntitlementDialog: false,
    fiscalYearList: [],
    holidayPeriodList: [
        {id: 1, name: 'Apr - Mar'},
        {id: 2, name: 'May - Apr'},
        {id: 3, name: 'Jan - Dec'}
    ]
};

const getDefaultState = () => {
    return {
        defaultPersonHolidayEntitlement: {
            personId: undefined,
            fiscalYear: undefined,
            carriedOver: 0,
            yearlyEntitlement: 0,
            specialAllowance: 0,
            comments: undefined,
            holidayPeriod: 1,
        },
    }
};

const years = function () {

    const currentYear = new Date().getFullYear();
    const tenYearsTime = currentYear + 10;
    const years = [];
    let startYear = 2015;


    while (startYear <= tenYearsTime) {
        years.push(startYear++);
    }
    return years;
};


const getters = {
    currentFiscalYear() {
        let fiscalyear = "";
        const today = new Date();
        if ((today.getMonth() + 1) <= 3) {
            fiscalyear = (today.getFullYear() - 1)
        } else {
            fiscalyear = today.getFullYear()
        }
        return fiscalyear
    },

    editPersonHolidayEntitlementInitialLoadFiscalYear(state) {
        return state.editPersonHolidayEntitlementInitialLoadFiscalYear;
    },
    fiscalYearList() {
        return years();
    },

    fiscalYearsRemainingForPersonExceptEditYearList(state, getters) {
        let exceptYear = false;
        if (getters.editPersonHolidayEntitlementInitialLoadFiscalYear) {
            exceptYear = getters.editPersonHolidayEntitlementInitialLoadFiscalYear;
        }

        const interimArray = Object.freeze(getters.fiscalYearList);
        let fiscalYearsRemainingForPersonList = JSON.parse(JSON.stringify(interimArray));
        const yearListToIterate = interimArray;

        let yearFoundInExistingHoliday = false;

        // Loop through years
        for (let i = 0; i <= yearListToIterate.length; i++) {
            const element = yearListToIterate[i];
            yearFoundInExistingHoliday = false;
            // Loop through persons holiday years
            for (let item of getters.personHolidayEntitlementList) {
                // If current fiscal year is in the person year list
                if (item.fiscalYear == element) {
                    yearFoundInExistingHoliday = true;
                    // If this year is not the except year then its in the list
                    if (item.fiscalYear == exceptYear) {
                        yearFoundInExistingHoliday = false;
                    }
                }
            }

            if (yearFoundInExistingHoliday) {
                const index = fiscalYearsRemainingForPersonList.indexOf(element);
                if (index !== -1) fiscalYearsRemainingForPersonList.splice(index, 1);
            }
        }
        return fiscalYearsRemainingForPersonList;
    },
    holidayPeriodList(state) {
        return state.holidayPeriodList;
    },
    addPersonHolidayEntitlementDialog(state) {
        return state.addPersonHolidayEntitlementDialog;
    },
    editPersonHolidayEntitlementDialog(state) {
        return state.editPersonHolidayEntitlementDialog;
    },
    personHolidayEntitlementList(state) {

        let personHolidayEntitlementListWithTotal = state.personHolidayEntitlementList;
        personHolidayEntitlementListWithTotal.forEach(function (item, key) {

            let total = item.carriedOver + item.yearlyEntitlement + item.specialAllowance;

            personHolidayEntitlementListWithTotal[key]['total'] = total;
        });


        return personHolidayEntitlementListWithTotal;
    },
    editedHolidayEntitlementItem(state) {
        return state.editedHolidayEntitlementItem;
    },
};

const actions = {
    [FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST]({commit}, personId) {
        if (personId == undefined) {
            return false;
        }
        return PersonnelService.getPersonHolidayEntitlements(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_HOLIDAY_ENTITLEMENTS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch holiday entitlement'});
            });
    },
    [CANCEL_PERSON_HOLIDAY_ENTITLEMENT_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST, params.personId);
        commit(TOGGLE_PERSON_HOLIDAY_ENTITLEMENT_EDIT_STATE, params.field);
    },
    [UPDATE_HOLIDAY_ENTITLEMENT]({commit, dispatch}, params) {
        return PersonnelService.updatePersonHolidayEntitlement(state.editPersonHolidayEntitlement)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_PERSON_HOLIDAY_ENTITLEMENT_TO_EDIT);
                dispatch(FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update holiday entitlement'});
            });
    },

    [DELETE_PERSON_HOLIDAY_ENTITLEMENT]({dispatch, commit}, params) {
        return PersonnelService.deletePersonHolidayEntitlement(params.personHolidayEntitlementId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete holiday entitlement'});
            });
    },
    [SAVE_NEW_PERSON_HOLIDAY_ENTITLEMENT]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonHolidayEntitlement = state.addPersonHolidayEntitlement;
        return PersonnelService.savePersonHolidayEntitlement(newPersonHolidayEntitlement)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST, newPersonHolidayEntitlement.personId);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save holiday entitlement'});
            });
    },

    [SAVE_EDITED_PERSON_HOLIDAY_ENTITLEMENT]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonHolidayEntitlement = state.editPersonHolidayEntitlement;
        return PersonnelService.updatePersonHolidayEntitlement(editedPersonHolidayEntitlement)
            .then(({data}) => {
                commit(RESET_DEFAULT_PERSON_HOLIDAY_ENTITLEMENT_TO_EDIT);
                dispatch(FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST, editedPersonHolidayEntitlement.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update holiday entitlement'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_NEW_PERSON_HOLIDAY_ENTITLEMENT_DIALOG](state) {
        state.addPersonHolidayEntitlementDialog = !state.addPersonHolidayEntitlementDialog;
    },
    [TOGGLE_EDIT_PERSON_HOLIDAY_ENTITLEMENT_DIALOG](state) {
        state.editPersonHolidayEntitlementDialog = !state.editPersonHolidayEntitlementDialog;
    },
    [RESET_DEFAULT_NEW_PERSON_HOLIDAY_ENTITLEMENT](state, personId) {
        state.addPersonHolidayEntitlement = getDefaultState().defaultPersonHolidayEntitlement;
        state.addPersonHolidayEntitlement.fiscalYear = undefined;
        state.addPersonHolidayEntitlement.personId = personId;
    },
    [RESET_DEFAULT_PERSON_HOLIDAY_ENTITLEMENT_TO_EDIT](state) {
        state.editPersonHolidayEntitlement = getDefaultState().defaultPersonHolidayEntitlement;
        state.editPersonHolidayEntitlementInitialLoadFiscalYear = false;
    },
    [LOAD_PERSON_HOLIDAY_ENTITLEMENT_TO_EDIT](state, holidayEntitlementId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personHolidayEntitlementList.find((list) =>
            list.personHolidayEntitlementId == holidayEntitlementId);
        // var interimArray =  Object.freeze(getters.fiscalYearList);
        // let fiscalYearsRemainingForPersonList = JSON.parse(JSON.stringify(interimArray));
        let frozenEditItem = Object.freeze(itemToEdit);
        let jsonedEditITem = JSON.parse(JSON.stringify(frozenEditItem));
        state.editPersonHolidayEntitlement = jsonedEditITem;
        const existingYear = jsonedEditITem.fiscalYear;
        state.editPersonHolidayEntitlementInitialLoadFiscalYear = existingYear;
    },
    [TOGGLE_PERSON_HOLIDAY_ENTITLEMENT_EDIT_STATE](state, field) {
        state.editStateHolidayEntitlement[field] = !state.editStateHolidayEntitlement[field];
    },
    [UPDATE_EDIT_PERSON_HOLIDAY_ENTITLEMENT_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonHolidayEntitlement[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonHolidayEntitlement[data.key] = data.value;
        }
    },
    [UPDATE_ADD_PERSON_HOLIDAY_ENTITLEMENT_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonHolidayEntitlement[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonHolidayEntitlement[data.key] = data.value;
        }
    },
    [FETCH_PERSON_HOLIDAY_ENTITLEMENTS_END](state, data) {
        state.personHolidayEntitlementList = data;
        //state.articlesCount = articlesCount;
        state.isLoading = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
